module.exports = __webpack_public_path__ + "static/media/lockedPadlockIcon.830bff08.svg";